import TemplatesContent from "components/Templates/templatesContent"
import React, { useEffect } from "react"
import { Helmet } from "react-helmet-async"
import { Container } from "reactstrap"
import { RecordPageView } from "App"
import * as amplitude from "@amplitude/analytics-browser"
import EntitlementPageGuard from "components/Subscription/EntitlementPageGuard"
import { TEMPLATES } from "constants/entitlements"

const Template = () => {
  RecordPageView()

  useEffect(() => {
    amplitude.track("Templates Visited")
  }, [])
  return (
    <EntitlementPageGuard permission={TEMPLATES}>
      <div className="page-content">
        <Helmet>
          <title>Planhopper | Plantillas </title>
        </Helmet>
        <Container fluid>
          <TemplatesContent />
        </Container>
      </div>
    </EntitlementPageGuard>
  )
}

export default Template
